import React from "react";
import { useAppContext } from "../../AppProvider";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { useShipmentOverviewContext } from "./providers/Overview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { useTypes } from "../../utilities/types";
import ZPLViewer from "../../Components/common/ZPLViewer";

const Overview: React.FC = () => {
  const { dictionary } = useAppContext();
  const { data, callback, loader } = useShipmentOverviewContext();
  const { currencies } = useTypes();

  const currency =
    currencies.find((c) => c.value === data.shipment?.goodsValueCurrency) ||
    null;
  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <div
            className="d-grid grid-column align-items-center"
            style={{ gridTemplateColumns: "auto" }}
          >
            <div>
              <label className="label-2">
                {dictionary.references.carrier_reference}:
              </label>
              <label className="label-3">
                {data.shipment?.carrierReference || "-"}
              </label>
            </div>
            <div className="text-end">
              <label className="label-2">{dictionary.words.price}:</label>
              <label className="label-3">
                {`${data.shipment?.ratingCost?.toFixed(2)} ${
                  currency?.label
                }` || "-"}
              </label>
            </div>
          </div>
          <div className="mt-2 text-center">
            {data.attachments?.[0].type?.format === "ZPL" ? (
              <ZPLViewer
                url={data.attachments?.[0].url}
                reference={data.shipment?.internalReference}
              />
            ) : (
              <iframe
                src={data.attachments?.[0].url}
                style={{ width: "100%", height: "500px" }}
              ></iframe>
            )}
          </div>
          <div className="d-flex mt-2">
            <ButtonUtility
              className="w-50 me-2"
              onClick={() => {
                if (callback) {
                  callback();
                }
              }}
            >
              {dictionary.actions.cancel}
            </ButtonUtility>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Overview;
